import cn from "../../lib/classnames";
import gradientStyles from "../../styles/Gradient.module.css";
import React from "react";
import styles from "./ExpandingCheckbox.module.css";
import textStyles from "../../styles/Text.module.css";
import TextLink from "../TextLink";

type Props = React.ComponentProps<"input"> & {
    children: (inputProps: {tabIndex?: number}) => React.ReactNode;
    label: string;
    hasGradient?: boolean;
    isChecked: boolean;
    to?: string;
    href?: string;
    linkText?: string;
    className?: string;
};

function ExpandingCheckbox(
    {
        children,
        label,
        hasGradient = false,
        isChecked,
        to,
        href,
        linkText,
        className,
        ...rest
    }: Props,
    ref: React.ForwardedRef<HTMLInputElement>,
) {
    const tabIndex = isChecked ? undefined : -1;

    return (
        <div>
            <div
                className={cn(
                    hasGradient ? styles.gradientContainer : undefined,
                    hasGradient ? gradientStyles.grey : undefined,
                    className,
                )}
            >
                <label className={cn(textStyles.inputPlaceholder, styles.labelContainer)}>
                    <input
                        className={styles.input}
                        checked={isChecked}
                        {...rest}
                        ref={ref}
                        type="checkbox"
                    />
                    <div className={cn(styles.checkbox, isChecked ? styles.checked : undefined)} />
                    <div className={styles.label}>{label}</div>
                </label>
                {linkText && (to || href) ? (
                    <TextLink className={styles.link} to={to} href={href} text={linkText} />
                ) : null}
            </div>
            <div className={cn(styles.content, isChecked ? styles.expanded : styles.collapsed)}>
                {children({tabIndex})}
            </div>
        </div>
    );
}

export default React.forwardRef<HTMLInputElement, Props>(ExpandingCheckbox);
